import CategoryService from '../../services/category.service'

export default {
  namespaced: true,
  state: {
    list: [],
    loading: false
  },
  mutations: {
    setCategories(state, categories) {
      state.list = categories
    },
    setLoading(state, value) {
      state.loading = value
    }
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true)
      try {
        const response = await CategoryService.getAll()
        commit('setCategories', response.data)
      } finally {
        commit('setLoading', false)
      }
    }
  },
  getters: {
    all(state) {
      return state.list
    }
  }
}
